import React from 'react'
import MaterialSymbol from '../material-symbol'

const Block = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="block" {...props} />
))

Block.displayName = 'Block'

export default Block
